import { render, staticRenderFns } from "./BasicLUMaintenance.vue?vue&type=template&id=40c15f8b"
import script from "./BasicLUMaintenance.vue?vue&type=script&lang=ts"
export * from "./BasicLUMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports